import { Tooltip } from '../ui/tooltip'

const SEVERANCE_TOOLTIP =
  'Severance agreement offered — $750 review available (does not change priority score)'

interface SeveranceBadgeProps {
  show?: boolean
  tooltipSide?: 'top' | 'bottom' | 'left' | 'right'
}

export function SeveranceBadge({ show, tooltipSide = 'top' }: SeveranceBadgeProps) {
  return (
    <span
      className="inline-flex h-6 w-5 flex-shrink-0 items-center justify-center overflow-visible"
      aria-hidden={!show}
    >
      {show ? (
        <Tooltip content={SEVERANCE_TOOLTIP} side={tooltipSide}>
          <span
            className="inline-flex box-border h-5 w-5 items-center justify-center rounded border border-violet-300 bg-violet-50 text-[10px] font-bold leading-none text-violet-800"
            aria-label={SEVERANCE_TOOLTIP}
          >
            S
          </span>
        </Tooltip>
      ) : null}
    </span>
  )
}
